module.exports = __webpack_public_path__ + "static/media/check.a4db314c.svg";